"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumAutoRecordType = exports.EnumAllowUnmuteBySelf = exports.EnumJoinPermission = exports.EnumCreatedFrom = exports.EnumMeetingType = exports.EnumMeetingState = void 0;
/**
 * 会议状态枚举
 */
var EnumMeetingState;
(function (EnumMeetingState) {
    /**
     * 非法或未知的会议状态
     */
    EnumMeetingState[EnumMeetingState["Invalid"] = -1] = "Invalid";
    /**
     * 待开始(未到预约结束时间且会议中无人)
     */
    EnumMeetingState[EnumMeetingState["Ready"] = 0] = "Ready";
    /**
     * 已取消(结束时间前且会议中无人时，被主持人取消，无法再进入)
     */
    EnumMeetingState[EnumMeetingState["Canceled"] = 1] = "Canceled";
    /**
     * 进行中(会议中有人)
     */
    EnumMeetingState[EnumMeetingState["Active"] = 2] = "Active";
    // 目前已结束会议列表包含 = Deleted\Ended\Recycled
    /**
     * 已删除(结束时间后且会议中无人时，被主持人删除，无法再进入)
     */
    EnumMeetingState[EnumMeetingState["Deleted"] = 3] = "Deleted";
    // AboutToBegin = 4, // 即将开始
    // Arrived = 5, // 已到预约开始时间
    /**
     *  无状态(过了预定结束时间，会议中无人)
     */
    EnumMeetingState[EnumMeetingState["Ended"] = 6] = "Ended";
    /**
     * 已回收(过了30天被回收，无法再进入)
     */
    EnumMeetingState[EnumMeetingState["Recycled"] = 7] = "Recycled";
})(EnumMeetingState = exports.EnumMeetingState || (exports.EnumMeetingState = {}));
/**
 * 会议类型枚举
 */
var EnumMeetingType;
(function (EnumMeetingType) {
    /**
     * 普通会议
     */
    EnumMeetingType[EnumMeetingType["NormalMeeting"] = 0] = "NormalMeeting";
    /**
     * 周期会议
     */
    EnumMeetingType[EnumMeetingType["PeriodicalMeeting"] = 1] = "PeriodicalMeeting";
    /**
     * 特邀会议
     */
    EnumMeetingType[EnumMeetingType["SpeciallyInvitedMeeting"] = 2] = "SpeciallyInvitedMeeting";
})(EnumMeetingType = exports.EnumMeetingType || (exports.EnumMeetingType = {}));
/**
 * 会议创建来源
 */
var EnumCreatedFrom;
(function (EnumCreatedFrom) {
    EnumCreatedFrom[EnumCreatedFrom["Web"] = 0] = "Web";
    EnumCreatedFrom[EnumCreatedFrom["WeworkBench"] = 1] = "WeworkBench";
    EnumCreatedFrom[EnumCreatedFrom["WeworkChat"] = 2] = "WeworkChat";
    /**
     * 工作台-预定会议-高级设置
     */
    EnumCreatedFrom[EnumCreatedFrom["AdvancedSettingsInWorkbench"] = 14] = "AdvancedSettingsInWorkbench";
    /**
    * 群聊-预定会议-高级设置
    */
    EnumCreatedFrom[EnumCreatedFrom["AdvancedSettingsInChatGroup"] = 15] = "AdvancedSettingsInChatGroup";
})(EnumCreatedFrom = exports.EnumCreatedFrom || (exports.EnumCreatedFrom = {}));
/**
 * 入会限制
 */
var EnumJoinPermission;
(function (EnumJoinPermission) {
    /**
     * 任何人可入会
     */
    EnumJoinPermission[EnumJoinPermission["Anyone"] = 0] = "Anyone";
    /**
     * 仅登录用户
     */
    EnumJoinPermission[EnumJoinPermission["LoggedUserOnly"] = 1] = "LoggedUserOnly";
    /**
     * 仅企业内部用户
     */
    EnumJoinPermission[EnumJoinPermission["EnterpriseInternal"] = 2] = "EnterpriseInternal";
})(EnumJoinPermission = exports.EnumJoinPermission || (exports.EnumJoinPermission = {}));
/**
 * 控制是否允许成员自我解除上行音频
 */
var EnumAllowUnmuteBySelf;
(function (EnumAllowUnmuteBySelf) {
    EnumAllowUnmuteBySelf[EnumAllowUnmuteBySelf["Prohibited"] = 0] = "Prohibited";
    EnumAllowUnmuteBySelf[EnumAllowUnmuteBySelf["Allow"] = 1] = "Allow";
})(EnumAllowUnmuteBySelf = exports.EnumAllowUnmuteBySelf || (exports.EnumAllowUnmuteBySelf = {}));
/**
 * 自动录制设置
 */
var EnumAutoRecordType;
(function (EnumAutoRecordType) {
    /**
     * 未开启自动录制
     */
    EnumAutoRecordType[EnumAutoRecordType["Off"] = 0] = "Off";
    /**
     * 开启自动本地录制
     */
    EnumAutoRecordType[EnumAutoRecordType["Local"] = 1] = "Local";
    /**
     * 开启自动云录制
     */
    EnumAutoRecordType[EnumAutoRecordType["Cloud"] = 2] = "Cloud";
})(EnumAutoRecordType = exports.EnumAutoRecordType || (exports.EnumAutoRecordType = {}));
//# sourceMappingURL=meeting.js.map